// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./SearchTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component */

.Search-module__Input__e8938 {
    all: unset;
    width: 100%;
    color: var(--ds-search-text-color);
    font-size: var(--ds-font-size-m);
    line-height: var(--ds-line-height-big);
    border: none;
    transition: width var(--ds-transition-s);
}

.Search-module__InlineIcon__AcB6U {
    color: var(--ds-font-color);
}

.Search-module__InputVisible__djdHj {
    width: var(--ds-32x);
}

.Search-module__InputHidden__c5QY5 {
    width: 0;
}

.Search-module__Input__e8938::placeholder {
    padding-left: var(--ds-xs);
    color: var(--ds-search-placeholder-color);
}
/* stylelint-enable property-disallowed-list -- DS component */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Input": `Search-module__Input__e8938`,
	"InlineIcon": `Search-module__InlineIcon__AcB6U`,
	"InputVisible": `Search-module__InputVisible__djdHj`,
	"InputHidden": `Search-module__InputHidden__c5QY5`
};
export default ___CSS_LOADER_EXPORT___;
